import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { TagStore } from '../../../stores/tag/tag.state';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

@Component({
  selector: 'app-product-filter-dropdown',
  standalone: true,
  imports: [
    MultiSelectModule,
    NgIf,
    SharedModule,
    FormsModule,
    IconFieldModule,
    InputIconModule,
  ],
  templateUrl: './product-filter-dropdown.component.html',
  styleUrl: './product-filter-dropdown.component.scss',
})
export class ProductFilterDropdownComponent {
  readonly tagStore = inject(TagStore);
  @Input() label = 'Bereich';
  @Input() selectedProducts?: string[] = [];
  @Output() selectedProductsChange = new EventEmitter<string[]>();

  /**
   * Handles changes to the tags by emitting the selectedProductsChange event
   * after a slight delay to ensure proper timing.
   *
   * @return {void} Does not return any value.
   */
  onTagsChange(): void {
    setTimeout(() => {
      this.selectedProductsChange.emit(this.selectedProducts);
    }, 10);
  }
}
